import type { JSX } from "react";
import type { Attribute } from "../sign-up-request";
import { Stack, Typography } from "@mui/material";
import { AttributeTextField } from "../components";
import { SignUpStep } from "../step";
import { useAutofocus } from "../util";


export class CompanyDetailsStep extends SignUpStep {
	override title: string = "Company Details";
	override view: () => JSX.Element = () => <CompanyDetailsStepView step={ this }/>;

	get companyName(): Attribute<string> {
		return this.app.state.attribute("companyName");
	}
	get website(): Attribute<string> {
		return this.app.state.attribute("website");
	}

	protected override async handleSubmit(): Promise<void> {
		await this.app.onCompanyDetailsProvided();
	}
}

const CompanyDetailsStepView = (p: { step: CompanyDetailsStep }): JSX.Element => {
	const autofocus = useAutofocus();

	return (
		<>
			<Typography component="p">
				Provide some details about your company.
			</Typography>

			<Stack gap={ 1 }>
				<AttributeTextField
					label="Company Name"
					inputRef={ autofocus }
					attribute={ p.step.companyName }
					required
				/>
				<AttributeTextField
					className="fullWidth"
					label="Website"
					attribute={ p.step.website }
				/>
			</Stack>
		</>
	);
};
